var modules_cc53b92d = {"menuTitle":"_f64qz0","menuContent":"_6vvvhm","menuItem":"_1ee9j8z","focused":"_2zx5ag","menuItemLabel":"_8y4w13","menuItemIcon":"_2cfs6f"};
import "../../assets/ORT5ITqA.css";

export { modules_cc53b92d as default };
//# sourceMappingURL=SuggestList.module.less.js.map
